import { render } from "./mobileHome.vue?vue&type=template&id=490b53a0&scoped=true"
import script from "./mobileHome.vue?vue&type=script&lang=js"
export * from "./mobileHome.vue?vue&type=script&lang=js"

import "./mobileHome.vue?vue&type=style&index=0&id=490b53a0&lang=less&scoped=true"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490b53a0"]])

export default __exports__